import { getEnv } from '../config';

const API_BASE_URL = getEnv('VITE_API_BASE_URL');

export interface SheetConfig {
  id: string;
  name: string;
  url?: string;
}

export interface LINEConfig {
  enabled: boolean;
  channel_id?: string;
}

export interface SystemConfig {
  sheets: Record<string, SheetConfig>;
  drive_folders: Record<string, string>;
  firestore_db: string;
  redis_url: string;
  ai_parse_enabled: boolean;
  line?: LINEConfig;
}

async function fetchWithAuth(url: string, options: RequestInit = {}): Promise<Response> {
  const token = localStorage.getItem('auth_token');
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };

  const response = await fetch(url, { ...options, headers });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || `HTTP error! status: ${response.status}`);
  }

  return response;
}

export async function getSystemConfig(): Promise<SystemConfig> {
  const response = await fetchWithAuth(`${API_BASE_URL}/api/v1/config`);
  return response.json();
}
